export const USER_AUTHEN = 'USER_AUTHEN'
export const USER_LINESTATUS = 'USER_LINESTATUS'
export const USER_PRLISTCOUNT = 'USER_PRLISTCOUNT'
export const USER_BUDGET = 'USER_BUDGET'
export const USER_BUDGETPROJECT = 'USER_BUDGETPROJECT'

export const FILE_UPLOAD = 'FILE_UPLOAD'
